module.exports = __webpack_public_path__ + "static/media/domains.545f642a.png";